window.buildUrlQuery = (params) => {
    const query = [];

    for (const key in params) {
        if (!params.hasOwnProperty(key)) continue;

        const value = params[key];
        const paramKey = encodeURIComponent(key);

        if (Array.isArray(value)) {
            value.forEach((item) => {
                query.push(`${paramKey}[]=${encodeURIComponent(item)}`);
            });
        } else if (value) {
            query.push(`${paramKey}=${encodeURIComponent(value)}`);
        }
    }

    return query.join("&");
};
